export default "__VITE_ASSET__BTE91B5z__"